<template>
  <div class="main_form_box">
    <div class="main_form_bar">
      <span>请选择人员组：</span>
      <div class="group_list_bar">
        <div
          v-for="item in userGroupList"
          :key="item.MeetingUserGroupID"
          :class="{
            group_item_active: selectUserGroupId === item.MeetingUserGroupID,
            group_item: selectUserGroupId !== item.MeetingUserGroupID
          }"
          @click="groupClick(item.MeetingUserGroupID)"
        >
          <i
            style="margin-right: 0px"
            class="iconfont"
            :class="{
              'icon-danxuanxuanzhong':
                selectUserGroupId === item.MeetingUserGroupID,
              'icon-weixuanzhong': selectUserGroupId !== item.MeetingUserGroupID
            }"
          ></i>
          {{ item.MeetingUserGroupName }}
        </div>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editUserGroup(null)"
        >
          新增组
        </el-link>
      </div>
    </div>
    <div class="main_form_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <el-button
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="exportTemplate()"
            :disabled="voteInfo.Status !== 0"
          >
            导出模板
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            size="mini"
            @click="importData()"
            :disabled="voteInfo.Status !== 0"
          >
            批量导入
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="editUser(null)"
            :disabled="voteInfo.Status !== 0"
          >
            新增人员
          </el-button>
          <el-button
            type="success"
            icon="iconfont icon-zhuchiren"
            size="mini"
            @click="editHostUser(null)"
            :disabled="voteInfo.Status !== 0"
            v-if="voteType === 3 || (voteType === 0 && voteInfo.IsScreen)"
          >
            新增主持人
          </el-button>
          <span class="select_message margin_left_20 margin_right_10">
            已选（{{ selectRows.length - zhuchirenItems.length }}）个评委
          </span>
          <span class="select_message margin_right_10" v-if="voteType === 3">
            ，已选（{{ zhuchirenItems.length }}）主持人
          </span>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">投票列表</el-button>
          <el-button
            type="primary"
            @click="editVoteUser(false)"
            size="small"
            :disabled="voteInfo.Status !== 0"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="editVoteUser(true)"
            :disabled="voteInfo.Status !== 0"
          >
            下一步
          </el-button>
        </div>
      </div>
      <div class="form_content" style="min-height: 500px">
        <el-table
          ref="multipleTable"
          :data="userList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @cell-mouse-leave="leaveCall"
          @row-click="selectRowChange"
          :row-class-name="tableRowClassName"
          stripe
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          >
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column property="UserName" label="姓名"> </el-table-column>
          <el-table-column property="Phone" label="用户名" align="center">
          </el-table-column>
          <el-table-column label="角色" align="center">
            <template slot-scope="scope">
              <span>
                <i
                  class="iconfont icon-zhuchiren"
                  v-if="scope.row.RoleId === 2"
                ></i>
                {{ scope.row.RoleName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            property="UserVoteNumber"
            label="权重(票数)"
            align="center"
          >
          </el-table-column>
          <el-table-column property="Sort" label="排序" align="center">
          </el-table-column>
          <!-- v-if="userRole === 1 && voteInfo.Status === 1" -->
          <el-table-column
            label="操作"
            align="center"
            v-if="voteInfo.Status === 1"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.IsSubmit"> 已提交 </span>
              <el-link
                type="primary"
                v-if="scope.row.IsSelect && !scope.row.IsSubmit"
                @click="deleteVoteUser(scope.row)"
              >
                移除
              </el-link>
              <el-link
                type="primary"
                v-if="!scope.row.IsSelect && !scope.row.IsSubmit"
                @click="insertVoteUser(scope.row)"
              >
                添加
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <ImportExcel
          :fatherSubmitDialog="importExcelDialog"
          ref="importUser"
        ></ImportExcel>
        <EditUserGroup
          :meetId="meetingId"
          :fatherSubmitDialog="editUserGroupDialog"
          ref="editUserGroup"
        ></EditUserGroup>
        <EditUser
          :MeetingGroupID="selectUserGroupId"
          :MeetingID="meetingId"
          :IsShowHeadPicture="isShowHeadPicture"
          :fatherSubmitDialog="editUserDialog"
          ref="editUser"
        ></EditUser>
        <EditHostUser
          :MeetingGroupID="selectUserGroupId"
          :MeetingID="meetingId"
          :IsShowHeadPicture="isShowHeadPicture"
          :fatherSubmitDialog="editHostUserDialog"
          ref="editHostUser"
        ></EditHostUser>
      </div>
    </div>
  </div>
</template>

<script>
import voteUserApi from '../../../api/vote/voteUser'
import voteManageApi from '../../../api/vote/voteManage'
import ImportExcel from '@/components/user/ImportExcel.vue'
import EditUserGroup from '@/components/user/EditUserGroup.vue'
import EditUser from '@/components/user/EditUser.vue'
import EditHostUser from '@/components/user/EditHostUser.vue'
export default {
  name: 'EditVoteUser',
  components: {
    ImportExcel,
    EditUserGroup,
    EditUser,
    EditHostUser
  },
  data () {
    return {
      meetingId: null,
      selectUserGroupId: null,
      userGroupList: [],
      groupListQuery: {
        meetingId: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      userList: [],
      listQuery: {
        meetingGroupID: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      selectRows: [],
      zhuchirenItems: [],
      voteUserInfo: {},
      isShowHeadPicture: false,
      voteType: 0,
      userRole: -1
    }
  },
  props: ['voteInfo'],
  inject: ['voteCheck', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    getDefaultUserGroup: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getDefaultUserGroup({
        meetingId: _this.groupListQuery.meetingId
      }).then(data => {
        if (!data) {
          _this.userGroupList.unshift({ MeetingUserGroupID: null, MeetingUserGroupName: '默认组', Sort: 0 })
        }
        if (!_this.selectUserGroupId) {
          if (_this.userGroupList.length > 0) {
            _this.selectUserGroupId = _this.userGroupList[0].MeetingUserGroupID
          }
        }
        _this.listQuery.meetingGroupID = _this.selectUserGroupId
        _this.getVoteUserInfo()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getVoteUserGroups: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getVoteUserGroups(_this.groupListQuery).then(data => {
        _this.userGroupList = data.Items
        _this.getDefaultUserGroup()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getVoteUsers: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getVoteUsers(_this.listQuery).then(data => {
        _this.userList = data.Items
        if (_this.userList !== null) {
          this.$nextTick(() => {
            _this.userList.forEach(function (row, index) {
              _this.$set(row, 'IsSelect', false)
              if (_this.voteUserInfo.VoteSelectUsers) {
                _this.voteUserInfo.VoteSelectUsers.forEach(function (selectItem, index) {
                  if (row.GroupStaffID.toLowerCase() === selectItem.GroupStaffId.toLowerCase()) {
                    _this.$refs.multipleTable.toggleRowSelection(row, true)
                    _this.$set(row, 'IsSubmit', selectItem.IsSubmit)
                    _this.$set(row, 'IsSelect', true)
                  }
                })
              }
            })
          })
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    groupClick: function (meetingGroupID) {
      this.selectUserGroupId = meetingGroupID
      this.listQuery.meetingGroupID = this.selectUserGroupId
      this.getVoteUsers()
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
      this.zhuchirenItems = []
      this.selectRows.map(item => {
        if (item.RoleId === 2) {
          this.zhuchirenItems.push(item)
        }
      })
    },
    hoverCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      if (column && column.label === '操作') {
        return
      }
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    checkSelectable: function (row) {
      if (this.voteInfo.Status !== 0) {
        return false
      } else {
        return true
      }
    },
    getVoteUserInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteManageApi.getVoteUserInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteUserInfo = data
        if (_this.voteUserInfo.UserGroupId) {
          _this.selectUserGroupId = this.voteUserInfo.UserGroupId
          _this.listQuery.meetingGroupID = _this.selectUserGroupId
        }
        _this.getVoteUsers()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    editVoteUser: function (isNext) {
      const _this = this
      const openLoading = _this.openLoading('保存中…')
      const selectIds = []
      this.selectRows.map(item => {
        selectIds.push(item.GroupStaffID)
      })
      this.voteUserInfo = {
        Id: this.$route.params.vid,
        SelectUserNum: this.selectRows.length,
        UserGroupId: this.selectUserGroupId,
        UserIds: selectIds
      }
      voteManageApi.editVoteUser(this.voteUserInfo).then(data => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!',
          customClass: 'custom_message'
        })
        if (isNext) {
          _this.$router.push({
            name: 'editVoteProject',
            params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid }
          })
        }
      }).catch(err => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        return err
      })
    },
    userGroupManager: function () {
      this.$router.push({ name: 'voteUserGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    },
    importData: function () {
      this.$refs.importUser.openImportExcel(this.selectUserGroupId, this.$route.params.mid)
    },
    importExcelDialog: function () {
      this.getVoteUserGroups()
    },
    editUserGroup: function (userGroupID) {
      this.$refs.editUserGroup.openEditUserGroup(userGroupID)
    },
    editUserGroupDialog: function () {
      this.getVoteUserGroups()
    },
    editUser: function (groupStaffId) {
      if (this.voteInfo.VoteType === 3) {
        this.isShowHeadPicture = true
      } else {
        this.isShowHeadPicture = false
      }
      this.$refs.editUser.openEditUser(groupStaffId)
    },
    editUserDialog: function () {
      //   if (this.selectUserGroupId) {
      //     this.getVoteUsers()
      //   } else {
      //     this.getVoteUserGroups()
      //   }
      this.getVoteInfo()
    },
    editHostUser: function (groupStaffId) {
      this.$refs.editHostUser.openEditUser(groupStaffId)
    },
    editHostUserDialog: function () {
      //   if (this.selectUserGroupId) {
      //     this.getVoteUsers()
      //   } else {
      //     this.getVoteUserGroups()
      //   }
      this.getVoteInfo()
    },
    exportTemplate: function () {
      const _this = this
      _this.openLoading()
      voteUserApi.exportMeetingUserTemplate({
        UserGroupID: _this.selectUserGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票人员'
        if (_this.selectUserGroupId) {
          _this.userGroupList.forEach(function (item, index) {
            if (item.MeetingUserGroupID === _this.selectUserGroupId) {
              fileName = item.MeetingUserGroupName
            }
          })
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xls')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getVoteInfo: function () {
      this.openLoading()
      if (this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: this.$route.params.vid
        }).then(data => {
          this.voteType = data.VoteType
          this.getVoteUserGroups()
          this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
      } else {
        this.openLoading().close()
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.RoleId === 2) {
        return 'zhuchiren-row'
      }
      return ''
    },
    deleteVoteUser: function (row) {
      const _this = this
      this.$confirm('确认从该投票删除投票人吗？投票人：' + row.UserName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.adjustVoteUser({
          VoteId: _this.$route.params.vid,
          GroupStaffId: row.GroupStaffID,
          Action: 'Delete'
        }).then(data => {
          _this.getVoteUserInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    insertVoteUser: function (row) {
      const _this = this
      this.$confirm('确认添加该投票人吗？投票人：' + row.UserName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.adjustVoteUser({
          VoteId: _this.$route.params.vid,
          GroupStaffId: row.GroupStaffID,
          Action: 'Insert'
        }).then(data => {
          _this.getVoteUserInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    }
  },
  created () {
    this.meetingId = this.$route.params.mid
    this.groupListQuery.meetingId = this.$route.params.mid
    this.getVoteInfo()
    this.getCurrentUserRole()
    // this.$root.$emit('routeChange')
    this.routeChange()
    // this.$root.$emit('voteCheck')
    this.voteCheck()
  }
}
</script>
<style lang="less">
.el-table .zhuchiren-row {
  background: #d9ecff;
}
</style>
